.root {
    margin: 1.25rem 0;
}

.item {
    border: 1px solid var(--article-border);
    background-color: var(--article-bg-subtle);
}

.control {
    padding: 0.625rem 1rem;
}

.label {
    font-family: var(--article-font-body);
    font-size: 0.875rem;
    font-weight: 700;
    color: var(--article-heading);
    letter-spacing: 0.01em;
}

.panel {
}

.content {
    padding: 0.75rem 1rem;
    font-size: 0.9375rem;

    p {
        margin-bottom: 0.625rem;
    }

    p:last-child {
        margin-bottom: 0;
    }

    table {
        margin: 0.5rem 0;
    }
}
